import { format } from 'date-fns';
import { FunctionComponent, useState } from 'react';
import { getWeights } from '../api/getWeights';
import { removeWeight } from '../api/removeWeight';
import { AddWeightButton } from './AddWeightButton';
import {
  Box,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
  Paper,
  TableHead,
  IconButton,
  Chip,
} from '@mui/material';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { WeightEntity } from '../types/weight';
import DeleteIcon from '@mui/icons-material/Delete';

export const Weights: FunctionComponent<{}> = () => {
  const [selected, setSelected] = useState<WeightEntity | undefined>();

  const queryClient = useQueryClient();

  const { isLoading, data } = useQuery('weights', getWeights);

  const deleteMutation = useMutation(removeWeight, {
    onSuccess: () => {
      queryClient.invalidateQueries('weights');
      setSelected(undefined);
    },
  });

  return isLoading ? (
    <>loading...</>
  ) : (
    <TableContainer component={Paper} sx={{ width: 350 }}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell colSpan={5} sx={{ pr: 1.5 }}>
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography>Weights</Typography>
                <Box display="flex" flexDirection="row" gap={0.5}>
                  <Typography>Diet streak</Typography>
                  <Chip size="small" label={data?.streak} color="success" />
                </Box>

                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  {selected && (
                    <>
                      <IconButton
                        onClick={() => deleteMutation.mutate(selected.id)}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </>
                  )}
                  <AddWeightButton />
                </Box>
              </Box>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody sx={{ borderTop: '2px solid lightgray' }}>
          {data?.weights.map((w) => (
            <TableRow
              key={w.id}
              sx={{
                borderBottom: w.bordered ? '2px solid lightgray' : undefined,
              }}
            >
              <TableCell sx={{ py: 0 }}>
                <Checkbox
                  size="small"
                  disabled={selected && selected.id !== w.id}
                  onChange={(e) =>
                    setSelected(e.target.checked ? w : undefined)
                  }
                />
              </TableCell>
              <TableCell sx={{ py: 0, px: 1 }}>
                {format(w.date, 'iii')}
              </TableCell>
              <TableCell align="center" sx={{ py: 0, px: 1 }}>
                {format(w.date, 'dd-MM-yyyy')}
              </TableCell>
              <TableCell align="right" sx={{ py: 0 }}>
                {w.weight.toFixed(2)}
              </TableCell>
              <TableCell
                align="center"
                sx={{ p: 0, px: 1, minWidth: 20, color: 'green' }}
              >
                <Chip
                  size="small"
                  label={w.calories ? w.calories : 'X'}
                  color={w.calories ? 'success' : 'error'}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
